import React from 'react';
import styled from 'styled-components';
import { Box, Divider } from '@99designs/emu';
import { mediaQuery } from '@99designs/emu/css';
import { borders, colors, spaces } from '@99designs/emu/settings';
import { ProductSummary, PropsWithProductSummary } from '@99designs/spa-common';
import { FeaturesList } from '@99designs/spa-common';

const FeaturesAndButtonWrapper = styled.div`
    padding-top: ${spaces['1.5bu']};
    align-items: flex-start;

    ${mediaQuery.minimum('normal')} {
        display: flex;
    }
`;

interface CardContainerStyleProps {
    hasLeftBorder: boolean;
}

const CardContainer = styled.div<CardContainerStyleProps>`
    padding: ${spaces['2bu']};
    border-radius: ${borders.borderRadiuses.medium}px;
    border-width: 1px;
    border-style: solid;
    border-color: ${colors.grey300};
    position: relative;

    ${({ hasLeftBorder }) =>
        hasLeftBorder &&
        `
        border-top-left-radius: 0px;
        border-bottom-left-radius: 0px;
        border-left: 0;
        margin-left: 25px;
        &::before {
            content: '';
            border-left: 25px solid ${colors.grey800};
            border-top-left-radius: ${borders.borderRadiuses.medium}px;
            border-bottom-left-radius: ${borders.borderRadiuses.medium}px;
            position: absolute;
            top: calc(0px - 1px);
            bottom: calc(0px - 1px);
            left: calc(0px - 25px);
        }
    `}
`;

export interface Feature {
    title: string;
    description?: string;
}

interface Props extends PropsWithProductSummary {
    features: Feature[];
    turnaround?: Feature;
    rightColumn: React.ReactNode;
    hasLeftBorder?: boolean;
}

export default function ProductCard({
    features,
    productSummary,
    turnaround,
    rightColumn,
    hasLeftBorder = true,
}: Props) {
    if (turnaround) {
        features = [...features, turnaround];
    }

    const mappedFeatures = features.map((feature) => {
        return {
            title: feature.title,
            isAvailable: true,
        };
    });

    if (productSummary.title === 'Wix Essential Package') {
        mappedFeatures.push({
            title: 'Ecommerce not included',
            isAvailable: false,
        });
    }

    return (
        <CardContainer hasLeftBorder={hasLeftBorder}>
            <Box marginBottom="1.5bu">
                <ProductSummary {...productSummary} />
            </Box>
            <Divider />
            <FeaturesAndButtonWrapper>
                <FeaturesList features={mappedFeatures} />
                <Box display="flex" flexDirection="column" alignSelf="flex-end">
                    {rightColumn}
                </Box>
            </FeaturesAndButtonWrapper>
        </CardContainer>
    );
}
